var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.96,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.96,
    y: 7,
    width: 15.09,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.96,
    cy: 16,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.96,
    y: 15,
    width: 15.09,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.96,
    cy: 24,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.96,
    y: 23,
    width: 15.09,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.c2fd4bf0.svg";
export { ForwardRef as ReactComponent };